import type { ReasonNode } from "web_myplann/Calculators/Types/ReasonNode";
import { translateToCzech } from "web_myplann/Calculators/Utils/translateToCzech";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useReasonOptions = <TReason extends string>(
	reasons: readonly TReason[],
	node: ReasonNode<TReason>,
) => {
	const { t } = useResource();

	return {
		options: reasons.map((reason) => ({
			value: reason,
			label: t(node[reason]),
		})),
		getLeadValue: (value: string) => {
			const reason = reasons.find((item) => item === value);

			return reason === undefined ? value : translateToCzech(node[reason]);
		},
	};
};
